import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  CustomTable,
  ModalError,
  ModalSuccess,
  ModalWarning,
  Page,
  PrimaryButton,
  PrimaryDeleteButton,
  PrimaryRestoreButton,
  SearchTextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { Fragment, useCallback, useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { emptyText, getErrors } from "utils";
import ModalFormParameterAssociation from "./components/ModalFormParameterAssociation";

function MasterAssociation() {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    per_page: 10,
    search: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const [preload, setPreload] = useState(0);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };
  const closeModal = () => {
    setModalVisible(false);
    setPreload(null);
  };
  const handleActivate = item => {
    const { is_active_flag, name } = item;
    ModalWarning(
      `Are you sure to ${is_active_flag ? "deactivate" : "restore"} ${name} ?`,
      `${is_active_flag ? "Deactivate" : "Restore"} Association`
    ).then(res => res?.isConfirmed && handleActivateUser(item));
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/association/index`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.per_page);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const handleActivateUser = async item => {
    const { is_active_flag, association_id } = item;
    try {
      setLoadingPage(true);
      if (is_active_flag) {
        await axios.delete(
          `${hardBaseUrl}/association/delete/${association_id}`,
          {
            headers,
          }
        );
      } else {
        await axios.put(
          `${hardBaseUrl}/association/recovery/${association_id}`,
          {},
          { headers }
        );
      }
      ModalSuccess(
        `Successfully ${is_active_flag ? "Deactivate" : "Restore"} Association`
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Fragment>
      <Page className={classes.root} title="Association">
        <Container maxWidth={false}>
          <HeaderTitle title="Parameter" breadcrumbData={breadcrumbData} />
          <ButtonGroupTop />
          <Divider className={classes?.flatDivider} />
          <Grid container justifyContent="space-between" my="16px">
            <Grid item>
              <SearchTextInput
                placeholder="Search"
                value={queryParams?.search}
                onChange={e =>
                  handleChangeQueryParams(e?.target?.value, "search")
                }
                disabled={loadingPage}
              />
            </Grid>
            <Grid item>
              <PrimaryButton
                label="Add Association"
                startIcon={<Add />}
                onClick={() => {
                  setModalVisible(true);
                  setPreload(null);
                }}
                size="large"
                disabled={loadingPage}
              />
            </Grid>
          </Grid>
          <CustomTable
            isLoading={loadingPage}
            columnTable={columnTable}
            data={dataTable}
            page={queryParams?.page}
            pageSize={queryParams?.per_page}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "per_page")
            }
            isHaveAction
            handleEdit={item => {
              setModalVisible(true);
              setPreload(item?.association_id);
            }}
            customAction={item =>
              item?.is_active_flag ? (
                <PrimaryDeleteButton
                  tooltipTitle="Deactivate Association"
                  onClick={() => handleActivate(item)}
                />
              ) : (
                <PrimaryRestoreButton
                  tooltipTitle="Restore Association"
                  onClick={() => handleActivate(item)}
                />
              )
            }
          />
        </Container>
      </Page>
      {modalVisible && (
        <ModalFormParameterAssociation
          open={modalVisible}
          onClose={closeModal}
          preload={preload}
          getData={getDataTable}
        />
      )}
    </Fragment>
  );
}

const breadcrumbData = [
  {
    label: "Parameter",
    link: "/admin/parameter/association",
  },
  {
    label: "Association",
    active: true,
  },
];
const columnTable = [
  {
    name: "name",
    title: "Association Name",
    renderText: item => emptyText(item),
  },
  {
    name: "pic",
    title: "Person In Charge",
    renderText: item => emptyText(item),
  },
  {
    name: "email",
    title: "Email",
    renderText: item => emptyText(item),
  },
  {
    name: "phone_number",
    title: "Phone",
    renderText: item => emptyText(item),
  },
];
export default MasterAssociation;
